function toggleIngredientModal(e) {
  e.preventDefault();
  document.getElementById('ingredient-modal').classList.toggle('hidden');
}


document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('ingredient-modal');
  if (modal) {
    modal.addEventListener('click', function (event) {
      if (!event.target.closest('.modal-content')) {
        modal.classList.add('hidden');
      }
    });
  }
});
